import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import Bell from '../../icons/Bell';
import { Tooltip } from '..';
import styles from './ResourceSentinelsQuickInfo.module.css';
import { SentinelTypeIcon } from '../../utils/sentinel';
import { SentinelBellSubMute, VolumeOff } from '../../icons';
import { shortenString } from '../../utils';
const ResourceSentinelsQuickInfo = ({ resourceId, sentinels, hideNumbers, arrowDirection, }) => {
    // const sentinelTypes = useMemo(() => {
    //   return [...new Set(sentinels.map(({ sentinelType }) => sentinelType))];
    // }, [sentinels])
    const mutedSentinelIdMapping = useMemo(() => {
        const mapping = {};
        sentinels.forEach(({ id: sentinelId, muted: sentinelIsMuted, mutedTargets }) => {
            const resourceIsMuted = (mutedTargets === null || mutedTargets === void 0 ? void 0 : mutedTargets.some(({ targetId }) => {
                return targetId === resourceId;
            })) || false;
            const isMuted = sentinelIsMuted || resourceIsMuted;
            if (isMuted)
                mapping[sentinelId] = isMuted;
        });
        return mapping;
    }, [sentinels, resourceId]);
    const hasMutedSentinels = Object.keys(mutedSentinelIdMapping).length;
    if (!sentinels.length)
        return null;
    return (_jsx(Tooltip, Object.assign({ content: _jsx(_Fragment, { children: sentinels
                .sort((a, b) => {
                const value = a.sentinelType.localeCompare(b.sentinelType);
                if (value === 0) {
                    return a.title.localeCompare(b.title);
                }
                return value;
            })
                .map(({ id, sentinelType, title }) => {
                const isMuted = mutedSentinelIdMapping[id];
                return (_jsxs("div", Object.assign({ className: styles.tooltipLine }, { children: [_jsxs("div", Object.assign({ style: { display: 'flex', marginRight: '1rem' } }, { children: [_jsx(SentinelTypeIcon, { type: sentinelType, size: 16 }, void 0), _jsx("div", Object.assign({ className: styles.sentinelTitle }, { children: shortenString(title, 12) }), void 0)] }), void 0), isMuted && (_jsx(VolumeOff, { style: { color: 'var(--ambient-basePlus50)' }, size: 16 }, void 0))] }), `${resourceId}${sentinelType}${id}`));
            }) }, void 0), arrowDirection: arrowDirection, disableAutoAdjust: true }, { children: _jsxs("div", Object.assign({ className: styles.root }, { children: [_jsx("div", { children: !hideNumbers && sentinels.length }, void 0), hasMutedSentinels ? (_jsx(SentinelBellSubMute, { className: styles.icon, size: 21 }, void 0)) : (_jsx(Bell, { className: styles.icon, size: 16 }, void 0))] }), void 0) }), void 0));
};
export default ResourceSentinelsQuickInfo;
